import { RatingPropertyType } from '../enums';
import { DEFAULT_RATING_OPTIONS } from '../constants';
import RatingItemProps from './RatingItemProps';

const RatingProps = {
  props: {
    ...RatingItemProps.props,
    [RatingPropertyType.Options]: {
      type: Array,
      default: () => DEFAULT_RATING_OPTIONS,
    },
  },
};

export default RatingProps;
